import axios from "axios";
import React, { useEffect } from "react";
import PropTypes from "prop-types";
import { Card } from "@mui/material";
import PollAnswer from "../../Polls/Components/PollAnswer";
import { POLLS_API_URL } from "../../Polls/Polls";

const PollsWidgetCard = (props) => {
    const {
        poll,
        showResults,
        pollHasBeenVoted,
        showThanksForVotingMessage,
        setShouldChangeToNextPoll,
        addPollIdToSessionVotedPolls,
        updateVotedPollAnswer,
        votedAnswerIds,
    } = props;
    const [pollWinner, setPollWinner] = React.useState("");
    const [isPollVoted, setPollVoted] = React.useState(false);

    useEffect(() => {
        calculatePollWinner();
        setPollVoted(poll.voted);
        shouldChangeToNextPoll();
    }, [isPollVoted]);

    const shouldChangeToNextPoll = () => {
        if (poll.voted) {
            setShouldChangeToNextPoll(true);
        } else {
            setShouldChangeToNextPoll(false);
        }
    };

    const calculatePollWinner = () => {
        let answerScores = {};
        poll.question.answers.map((answer) => {
            answerScores[answer.id] = answer.responses;
        });

        let pollScores = Object.values(answerScores);
        let maxScore = Math.max(...pollScores);
        let maxIndex = pollScores.indexOf(maxScore);
        let drawScores = pollScores.filter((score) => score === maxScore);

        if (drawScores.length <= 1) {
            setPollWinner(pollScores[maxIndex]);
        }
    };

    const vote = (answerId) => {
        if (isPollVoted) {
            return;
        }
        axios
            .post(`${POLLS_API_URL}polls/${poll.id}/vote`, {
                answer_id: answerId,
            })
            .then(({ data: answer }) => {
                setPollVoted(true);
                updateVotedPollAnswer(poll.id, answer);
                addPollIdToSessionVotedPolls(poll.id);
                pollHasBeenVoted(setPollVoted);
                showThanksForVotingMessage();
            })
            .catch((error) => {
                console.log(error);
            });
    };

    return (
        <div className="polls-card-container">
            <Card className="polls-card">
                <div className="cell question padding-vertical-1">
                    {poll.question.question}
                </div>
                <div className="grid-x padding-vertical-1 polls-card-answers">
                    {poll.question.answers.map((answer) => {
                        return (
                            <PollAnswer
                                answer={answer}
                                isPollVoted={isPollVoted}
                                key={answer.id}
                                poll={poll}
                                pollWinner={+pollWinner}
                                showResults={showResults}
                                vote={vote}
                                votedAnswerIds={votedAnswerIds}
                            />
                        );
                    })}
                </div>
            </Card>
        </div>
    );
};

PollsWidgetCard.propTypes = {
    showResults: PropTypes.bool,
};

PollsWidgetCard.defaultProps = {
    showResults: false,
    onEvent: null,
};

export default PollsWidgetCard;
